import axioInstance from "../../custom_utilities/AxiosInstance/axiosInstance";

const AITS_TESTLIST_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/practice_testlist";
  

const aitsApi = {
  getAitsTestList: async ({
    paperType,
    plannerId,
    plannerTestType,
    year,
    format,
    categoryId,
  }) => {
    const res = await axioInstance.get(
      `${AITS_TESTLIST_URL}?paper_type=${paperType}&planner_id=${plannerId}&planner_test_type=${plannerTestType}&year=${year}&format=${format}&category_id=${categoryId}`
    );
    return res.data;
  },
};

export default aitsApi;
